module.exports = __webpack_public_path__ + "1b45ce2fc81ea3ebc6680b163c298f63.svg";